class SlideControler {

    //
    //  SlideControler
    //  Eigen wrapper rondom presentation slide element
    //

    constructor( _container ) {
      this.version = 1.0;
      this.container = _container;
      this.slide_category_menu = null;
      this.slide_category_dots = null;
      this.videocontroler = null;
      this.blocktimer = null;
      this.animating = false;
      this.mousewheel_paused = false; // mousewheel events
      this.touch_y = 0; // touchmove events

      this.add_hooks();
      this.slide_category_menu = document.querySelector('.slide-category__menu');
      this.slide_category_dots = document.querySelector('.slide-category__dots');
    }

    connect_videocontroler( _videocontroler ) {
      this.videocontroler = _videocontroler;
    }

    add_hooks() {
      var self = this;

      jQuery('[video-next]').on('click', function(e) {
        e.preventDefault();
        self.next();
      });

      jQuery('[video-previous]').on('click', function(e) {
        e.preventDefault();
        self.previous();
      });

      jQuery('[video-goto]').on('click', function(e) {
        e.preventDefault();
        self.goto( this.getAttribute('video-goto') );
      });

      jQuery('body').on('wheel mousewheel', function(e) {
        if( !self.animating ) {
          if( !self.mousewheel_paused ) {
            self.pause_mousewheel();
            if(e.originalEvent.deltaY > 0) {
              self.next();
            } else {
              self.previous();
            }
          } else {
            if( Math.abs(e.originalEvent.deltaY) > 20 )
              self.show_blocked();
          }
        }
      });

      jQuery('body').on('touchstart', function(e) {
        if( !self.animating ) {
          self.touch_y = e.changedTouches[0].pageY;
        } else {
          self.show_blocked();
        }
      });

      jQuery('body').on('touchend', function(e) {
        if( !self.animating ) {
          var movement_treshold = 40; //px
          var movement = self.touch_y - e.changedTouches[0].pageY;
          if( Math.abs(movement) > movement_treshold ) {
            if( movement > 0 ) {
              self.next();
            } else {
              self.previous();
            }
          }
        }
      });

      jQuery('body').on('keyup', function(e) {
        if( !self.animating ) {
          if(e.which === 40) {
            self.next();
          } else if( e.which == 38) {
            self.previous();
          }
        } else {
          self.show_blocked();
        }
      });

    }

    show_blocked() {
      if( this.blocktimer ) {
        clearTimeout(this.blocktimer);
      }
      if( !document.body.classList.contains('is-blocking-events')) {
        document.body.classList.add('is-blocking-events');
      }
      this.blocktimer = setTimeout( () => { document.body.classList.remove('is-blocking-events'); }, 500);
    }

    pause_mousewheel() {
      var self = this;
      var mousewheel_interval = 1500; //ms
      self.mousewheel_paused = true;
      setTimeout( () => { self.mousewheel_paused = false; }, mousewheel_interval);
    }

    get_current_slide() {
      return this.container.querySelector('.active');
    }

    start() {
      if( this.videocontroler ) {
        let slide = this.get_current_slide();
        let start = slide.getAttribute('video-start');
        let pause = slide.getAttribute('video-pause');
        this.videocontroler.set( start, pause );
      }
    }

    next() {
      if( this.videocontroler && !this.animating) {
        let slide = this.get_current_slide();
        let next = slide.nextElementSibling;
        if( next && next.classList.contains('panel') )
          next = next.nextElementSibling;
        if( next ) {
          let start = next.getAttribute('video-start');
          let pause = next.getAttribute('video-pause');
          this.videocontroler.set( start, pause );
          this.transition(slide, next);
        }
      } else {
        this.show_blocked();
      }
    }

    previous() {
      if( this.videocontroler && !this.animating) {
        let slide = this.get_current_slide();
        let previous = slide.previousElementSibling;
        if( previous && previous.classList.contains('panel') )
          previous = previous.previousElementSibling;
        if( previous ) {
          let start = previous.getAttribute('video-start');
          let pause = previous.getAttribute('video-pause');
          this.videocontroler.set( start, pause );
          this.transition(slide, previous);
        }
      } else {
        this.show_blocked();
      }
    }

    goto( _classname ) { // example: .slide-3
      if( this.videocontroler && !this.animating ) {
        let slide = this.get_current_slide();
        let next = this.container.querySelector('.'+_classname);
        if( next ) {
          let start = next.getAttribute('video-start');
          let pause = next.getAttribute('video-pause');
          this.videocontroler.set( start, pause );
          this.transition(slide, next);
        }
      } else {
        this.show_blocked();
      }
    }

    get_direction(old_slide, new_slide) {
      var old_index = [...this.container.children].indexOf(old_slide);
      var new_index = [...this.container.children].indexOf(new_slide);
      return (new_index - old_index > 0)
        ? 'forward'
        : 'backwards';
    }

    animation_started() {
      this.animating = true;
      document.body.classList.add('is-animating');
    }

    animation_ended() {
      document.body.classList.remove('is-animating');
      this.animating = false;
    }

    handle_slide_category_menu_and_dots(old_category, new_category) {
      if( old_category == new_category ) return;
      if( old_category ) {
        if(this.slide_category_menu !== null)
          this.slide_category_menu.classList.remove(old_category);
        if(this.slide_category_dots !== null)
          this.slide_category_dots.classList.remove(old_category);
      }
      if(this.slide_category_menu !== null)
        if( !this.slide_category_menu.classList.contains(new_category) ) {
          this.slide_category_menu.classList.add(new_category);
        }
      if(this.slide_category_dots !== null)
        if( !this.slide_category_dots.classList.contains(new_category) ) {
          this.slide_category_dots.classList.add(new_category);
        }
    }

    transition(old_slide, new_slide) {
      if( old_slide == new_slide) return;

      // console.log(old_slide, new_slide);

      var speed_factor = 0.75; // 1= normaal, 0.5 = 2x zo snel

      var self = this;
      self.animation_started();

      let direction = self.get_direction(old_slide, new_slide);
      let old_category = old_slide === null 
        ? ''
        : old_slide.getAttribute('slide-category');
      let new_category = new_slide.getAttribute('slide-category');
      new_slide.classList.add('active');
      self.handle_slide_category_menu_and_dots(old_category, new_category);

      let text_delay = parseFloat(new_slide.getAttribute('text-delay'));
      if( isNaN(text_delay) ) text_delay = 0;

      let panel_delay = parseFloat(new_slide.getAttribute('panel-delay'));
      if( isNaN(panel_delay) ) panel_delay = 0;

      if( gsap ) {
        var panel_time  = 0;
        var reveal_time = 0;

        var tl = gsap.timeline({onComplete: function(){
          if( old_slide !== null ) {
            old_slide.classList.remove('active');
          }
          self.animation_ended();
          this.kill();
        }});

        // transitions - panel

        var panel;
        if( new_category == 'missie' && old_category != 'missie') { // open
          reveal_time = panel_delay + 0.5;
          panel_time = panel_delay + 0;
          panel = document.querySelector('.panel-background');

          if( panel )
          // tl.to(panel, 
          //   {
          //     duration: 2 * speed_factor,
          //     ease: "power4",
          //     // width: "50vw",
          //   }, panel_time);
          tl.set(panel, { className : "panel panel-background panel--open"}, panel_time);
        } else if( old_category == 'missie' && new_category != 'missie') { // close
          reveal_time = 0;
          panel_time = 0.25;
          panel = document.querySelector('.panel-background');

          if( panel )
          // tl.to(panel, 
          //   {
          //     duration: 1 * speed_factor,
          //     ease: "power4",
          //     width: 0,
          //   }, panel_time);
          tl.set(panel, { className : "panel panel-background"}, panel_time);
        }

        // transitions - reveal default
        var hide_lines = (old_slide === null) ? false : old_slide.querySelector('.reveal');
        if( hide_lines ) {
          tl.fromTo(hide_lines, 
            {
              autoAlpha: 1,
              y: 0
            },
            {
              duration: 1 * speed_factor,
              ease: "power4",
              autoAlpha: 0,
              y: (direction == 'forward') ? "-=5vh" : "+=5vh",
              clearProps: "y"
            }, 0);
        }

        var reveal_lines = new_slide.querySelector('.reveal');
        if( reveal_lines ) {
          tl.fromTo(reveal_lines, 
            {
              autoAlpha: 0,
              y: (direction == 'forward') ? "+=5vh" : "-=5vh",
            },
            {
              duration: 2 * speed_factor,
              ease: "power4",
              autoAlpha: 1,
              y: 0,
              clearProps: "y"
            }, text_delay + reveal_time);
        }

        // transitions - reveal big

        var hide_lines_big = (old_slide === null) ? false : old_slide.querySelector('.reveal-big');
        if( hide_lines_big ) {
          tl.fromTo(hide_lines_big, 
            {
              autoAlpha: 1,
              y: 0
            },
            {
              duration: 1 * speed_factor,
              ease: "power4",
              autoAlpha: 0,
              y: (direction == 'forward') ? "-=50vh" : "+=50vh",
              clearProps: "y"
            }, reveal_time);
        }

        var reveal_lines_big = new_slide.querySelector('.reveal-big');
        if( reveal_lines_big ) {
          tl.fromTo(reveal_lines_big, 
            {
              autoAlpha: 0,
              y: (direction == 'forward') ? "+=50vh" : "-=50vh",
            },
            {
              duration: 2 * speed_factor,
              ease: "power4",
              autoAlpha: 1,
              y: 0,
              clearProps: "y"
            }, text_delay + reveal_time);
        }
        // transitions - done

      } else {
        console.log('Geen greensock gevonden.');
      }

    }

}